import PropTypes from 'prop-types';
import React from 'react';
import { connect } from 'react-redux';
import { Flex, Box } from 'reflexbox';
import { Button, Textarea } from 'rebass';
import { withRouter, routerShape } from 'react-router';

import actions from 'frontend/state/actions';
import { selectors as simbotSelectors } from 'frontend/state/reducers/simbot';

import SvgIcons from 'frontend/SvgIcons';
import config from 'frontend/config';

import SimcInput from 'shared/simcinput';
import ToggleView from 'frontend/components/ToggleView';
import CopyToClipboard from 'frontend/components/CopyToClipboard';

const RawSimcInput = ({ formData, inputForm, router }) => {
  const data = SimcInput.formInputToData({
    ...formData,
    verbose: true,
  });
  const value = SimcInput.stringify(data);
  const label = (
    <Flex align="center">
      <Box mr={1}>
        <SvgIcons.showInput.small
          style={{
            fill: config.colors.iconInfo,
            width: 26,
            height: 26,
          }}
        />
      </Box>
      <Box>Show Simc Input</Box>
    </Flex>
  );
  return (
    <Box>
      <ToggleView label={label} eventLabel="Show Simc Input" defaultOpen={false}>
        <Box ml={2} pl={2} style={{ borderLeft: `1px solid ${config.colors.midgray}` }}>
          <Textarea
            label=""
            name="showSimcInput"
            rows={6}
            value={value}
            backgroundColor="rgba(255,255,255,.45)"
            readOnly
            mb={0}
          />
          <CopyToClipboard value={value} />
          <Button
            onClick={() => {
              inputForm('advancedInput', value);
              router.replace('/simbot/advanced');
            }}
            ml={2}
            p={1}
            style={{
              marginTop: '3px',
              fontSize: '9px',
              minHeight: '30px',
              lineHeight: '9px',
              width: '170px',
            }}
          >
            Copy to Advanced
          </Button>
        </Box>
      </ToggleView>
    </Box>
  );
};

RawSimcInput.propTypes = {
  formData: PropTypes.shape({
    armory: PropTypes.object,
    // lots more fields
  }).isRequired,
  inputForm: PropTypes.func.isRequired,
  router: routerShape.isRequired,
};

const mapStateToProps = (state, props) => ({
  formData: simbotSelectors.formData(state, props),
});

const mapDispatchToProps = {
  inputForm: actions.inputForm,
};

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(RawSimcInput));
